module.exports = __webpack_public_path__ + "img/27.6c3f2f4a.jpg";